import Logo from "@/components/header/logo";
import Detalhes from "@/features/Detalhes";
import StepAcordions from "@/components/acorddions/stepAcordions";
import Usuario from "@/features/Usuario";
import Sucesso from "@/features/Sucesso";
import Rodape from "@/features/Rodape";
import {useSelector} from "react-redux";
import {GET_USER_STEP, GET_USER_TAB} from "@/store/slices/appSlice";
import Voucher from "@/features/Voucher";
import PrecisaAjuda from "@/features/PrecisaAjuda";
import Chat from "@/features/Chat";
import Mensagem from "@/features/Mensagem";
import Modals from "@/components/modals";

import { GET_USER } from "@/store/slices/userSlice";

export default function PrePago() {
    const USER_TAB = useSelector(GET_USER_TAB)
    const finishStep = 3;
    const current = useSelector(GET_USER_STEP)
    const USER = useSelector(GET_USER)

    return (
        <>
            <Logo/>
            <Detalhes/>
            <StepAcordions title={'Identificação'} subtitle={USER.email} step={'1'} page="voucher">
                <Usuario></Usuario>
            </StepAcordions>
            <StepAcordions title={'Assinar'} step={'2'}>
                <Voucher></Voucher>
            </StepAcordions>
            {current === finishStep && <Sucesso />}
            <PrecisaAjuda />
            {USER_TAB === 3 && 
            <>
                <Chat />
                <Mensagem />
            </>            

            }
            <Rodape />
            <Modals />
        </>
    )
}
